<template>
  <div class="page-container">
    <div ref="homePage" class="home-page" :class="{ 'locale-zh-CN': isZhLocale }">
    <!-- 头部大图 -->
    <div class="header-banner" :style="{ backgroundImage: `url(${config.header.backgroundImage})` }">
      <!-- 顶部导航栏 -->
      <div class="top-navbar">
        <div class="navbar-content">
          <div class="logo-area">
            <img :src="safeLogo" alt="logo" class="logo" @error="onImgError" />
            <span class="site-title">{{ config.siteInfo.title }}</span>
          </div>
          <div class="right-cluster">
            <el-dropdown class="lang-entry" trigger="click" @command="handleLocaleCommand">
              <span class="el-dropdown-link">
                {{ currentLocaleLabel }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="zh-CN">中文</el-dropdown-item>
                <el-dropdown-item command="en-US">English</el-dropdown-item>
                <el-dropdown-item command="ru-RU">Русский</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <div class="auth-area">
              <template v-if="isLoggedIn">
                <span
                  class="auth-link nick"
                  :title="userInfo.nickName || userInfo.userId || getText('pageHeader.userFallback')"
                  @click="handleUserCenter"
                >
                  <img v-if="userInfo.avatar" :src="safeAvatar" alt="avatar" class="avatar" @error="onImgError" />
                  {{ userInfo.nickName || userInfo.userId || getText('pageHeader.userFallback') }}
                </span>
                <span class="divider">|</span>
                <span class="auth-link" @click="handleLogout">{{ config.siteInfo.logoutText }}</span>
              </template>
              <template v-else>
                <span class="auth-link" @click="handleLogin">{{ config.siteInfo.loginText }}</span>
                <span class="divider">|</span>
                <span class="auth-link" @click="handleRegister">{{ config.siteInfo.registerText }}</span>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="banner-content">
        <!-- 标题 -->
        <div class="header-title" v-if="false">
          <img :src="safeTitleImage" alt="title" class="title-image" @error="onImgError" />
        </div>

        <!-- 搜索框（暂时隐藏） -->
        <div class="search-container" v-if="false">
          <div class="search-box">
            <img src="@/assets/img/shouye/search-ico.png" alt="search" class="search-icon" />
            <input
              v-model="searchKeyword"
              type="text"
              :placeholder="config.header.searchPlaceholder"
              class="search-input"
              @keyup.enter="handleSearch"
            />
            <button class="search-button" @click="handleSearch">
              {{ config.header.searchButton }}
            </button>
          </div>

          <!-- 热门搜索 -->
          <div class="hot-search">
            <span class="hot-title">{{ config.hotSearch.title }}</span>
            <span
              v-for="(keyword, index) in config.hotSearch.keywords"
              :key="index"
              class="hot-keyword"
              @click="handleHotSearch(keyword)"
            >
              {{ keyword }}
            </span>
            <div class="action-box">
              <span>{{ config.hotSearch?.historySearch }}</span>｜<span>{{ config.hotSearch?.clearHistory }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 机器人客服 -->
      <div class="ai-service">
        <div class="ai-robot" @click.stop="toggleAiMenu">
          <img :src="safeAiRobotImage" alt="AI客服助手" class="robot-icon" @error="onImgError" />
          <img :src="safeHiImage" alt="hi" class="ai-hi" @error="onImgError" />
        </div>
        <transition name="ai-menu-fade">
          <div v-if="aiMenuVisible" class="ai-menu">
            <div
              v-for="item in aiMenuItems"
              :key="item.key"
              class="ai-menu-item"
              @click.stop="handleAiMenuClick(item)"
            >
              <img :src="getSafeImageLocal(item.icon)" :alt="item.label" class="ai-menu-icon" @error="onImgError" />
              <span class="ai-menu-text">{{ item.label }}</span>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <!-- 功能模块 -->
        <div class="function-modules">
      <div class="modules-container">
        <div v-for="module in navModules" :key="module.id" class="module-item" @click="handleModuleClick(module)">
            <div class="module-icon">
              <img :src="getSafeImageLocal(module.icon)" :alt="module.name" @error="onImgError" />
          </div>
          <div class="module-info">
            <div class="module-name">{{ module.name }}</div>
            <div v-if="isZhLocale && module.enName" class="module-en-name">{{ module.enName }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 内容区域 -->
    <div class="content-area">
      <div class="content-wrapper">
        <!-- 科技动态 -->
        <NewsBlock
          theme="homepage"
          :title="config.techTrends.title"
          :subtitle="config.techTrends.subTitle"
          :tabs="config.techTrends.tabs"
          :active-tab="activeTechTab"
          :more-text="config.techTrends.moreText"
          :news-list="techNewsList"
          @tab-change="activeTechTab = $event"
          @more-click="handleMoreClick('tech')"
          @news-click="(item) => handleNewsClick(item, 'tech')"
        />

        <!-- 政策信息 -->
        <NewsBlock
          theme="homepage"
          :title="config.policyInfo.title"
          :subtitle="config.policyInfo.subTitle"
          :tabs="config.policyInfo.tabs"
          :active-tab="activePolicyTab"
          :more-text="config.policyInfo.moreText"
          :news-list="policyNewsList"
          @tab-change="activePolicyTab = $event"
          @more-click="handleMoreClick('policy')"
          @news-click="(item) => handleNewsClick(item, 'policy')"
        />

        <!-- 发布需求 -->
        <div class="publish-demand" :style="{ backgroundImage: `url(${config.publishDemand.backgroundImage})` }">
          <!-- 发布成果 -->
          <div class="demand-section">
            <div class="section-title">{{ config.publishDemand?.publishedTitle }}</div>
            <div class="number-display">
              <div class="digit-box" v-for="(digit, index) in publishedNumberArray" :key="'published-' + index">
                {{ digit }}
              </div>
              <div class="unit-text">{{ config.publishDemand?.unit }}</div>
            </div>
          </div>
          
          <!-- 发布需求 -->
          <div class="demand-section">
            <div class="section-title">{{ config.publishDemand?.pendingTitle }}</div>
            <div class="number-display">
              <div class="digit-box" v-for="(digit, index) in pendingNumberArray" :key="'pending-' + index">
                {{ digit }}
              </div>
              <div class="unit-text">{{ config.publishDemand?.unit }}</div>
            </div>
          </div>
          
          <div class="demand-subtitle">{{ config.publishDemand.subtitle }}</div>
          <div class="demand-button" @click="handlePublish">
            <img :src="safePublishButtonImage" :alt="config.publishDemand.buttonText" @error="onImgError" />
          </div>
        </div>
      </div>
    </div>

    <!-- 页脚 -->
      <PageFooter />
    </div>

    <!-- 专家咨询弹窗 -->
    <DemandMatchDialog
      :visible.sync="consultVisible"
      moduleType="demand"
      :project="consultProject"
      source-type="consult"
    />
  </div>
</template>

<script>
import { applyPageScale, setupPageScaleObserver, teardownPageScaleObserver } from '@/utils/pageScale'
import { getHomeConfig, filterNavModules } from '@/config/homeConfig'
import NewsBlock from '@/components/NewsBlock.vue'
import PageFooter from '@/components/PageFooter.vue'
import DemandMatchDialog from '@/components/DemandMatchDialog.vue'
import { getNoticeList } from '@/api/home'
import supplyDemandApi from '@/api/supplyDemand'
import request from '@/utils/request'
import commonApi from '@/api/common'
import aiRobotImage from '@/assets/img/ai/ai.png'
import hiImage from '@/assets/img/ai/hi.png'
import iconQa from '@/assets/img/ai/zhinengwenda.png'
import iconConsult from '@/assets/img/ai/kefu-zhuanjiazixun-ico.png'
import iconNeed from '@/assets/img/ai/fabuxuqiu.png'
import iconResult from '@/assets/img/ai/fabuchengguo.png'
import iconOrg from '@/assets/img/ai/danweiruzhu.png'
import iconTalent from '@/assets/img/ai/rencairuzhu.png'
import iconHelp from '@/assets/img/ai/bangzhushouce.png'
import { getSafeImage, handleImgError } from '@/utils/imageFallback'
import { getText, getCurrentLocale, setPortalLocale } from '@/utils/i18nText'
import { reportSearchIfKeyword } from '@/utils/behaviorTrack'
import { normalizeNewsNavItem, setNewsNavList } from '@/utils/newsNav'

export default {
  name: 'HomePage',
  components: {
    PageFooter,
    NewsBlock,
    DemandMatchDialog
  },
  data() {
    return {
      config: {},
      searchKeyword: '',
      activeTechTab: 'news',
      activePolicyTab: 'tech',
      techNewsList: [],
      policyNewsList: [],
      // 发布统计数据（按需求指定）
      publishedNumber: 3031, // 发布成果
      pendingNumber: 114,    // 发布需求
      // 用户信息
      isLoggedIn: false,
      userInfo: {
        nickName: '',
        userId: '',
        avatar: ''
      },
      loadingUser: false,
      // AI 客服
      aiMenuVisible: false,
      consultVisible: false,
      consultProject: {},
      aiRobotImage,
      hiImage,
      aiMenuItems: [
        { key: 'qa', label: getText('homePage.aiMenu.qa'), icon: iconQa },
        { key: 'consult', label: getText('homePage.aiMenu.consult'), icon: iconConsult },
        { key: 'need', label: getText('homePage.aiMenu.need'), icon: iconNeed },
        { key: 'result', label: getText('homePage.aiMenu.result'), icon: iconResult },
        { key: 'org', label: getText('homePage.aiMenu.org'), icon: iconOrg },
        { key: 'talent', label: getText('homePage.aiMenu.talent'), icon: iconTalent },
        { key: 'help', label: getText('homePage.aiMenu.help'), icon: iconHelp }
      ]
    }
  },
  computed: {
    currentLocaleLabel() {
      const map = {
        'zh-CN': '中文',
        'en-US': 'English',
        'ru-RU': 'Русский'
      }
      return map[getCurrentLocale()] || '中文'
    },
    // 将发布成果数字拆分为数组
    publishedNumberArray() {
      return String(this.publishedNumber).split('')
    },
    // 将发布需求数字拆分为数组
    pendingNumberArray() {
      return String(this.pendingNumber).split('')
    },
    safeLogo() {
      return getSafeImage(this.config.siteInfo?.logo)
    },
    safeAvatar() {
      return getSafeImage(this.userInfo.avatar)
    },
    safeTitleImage() {
      return getSafeImage(this.config.header?.titleImage)
    },
    safeAiRobotImage() {
      return getSafeImage(aiRobotImage)
    },
    safeHiImage() {
      return getSafeImage(hiImage)
    },
    safePublishButtonImage() {
      return getSafeImage(this.config.publishDemand?.buttonImage)
    },
    navModules() {
      return filterNavModules(this.config.modules)
    }
  },
  created() {
    this.loadConfig()
    this.loadTechNews()
    this.loadPolicyNews()
    this.loadPublishStats()
  },
  watch: {
    activeTechTab() {
      // tab切换时根据类型重新加载科技动态
      this.loadTechNews()
    },
    activePolicyTab() {
      // tab切换时根据类型重新加载政策信息
      this.loadPolicyNews()
    }
  },
  mounted() {
    this.fetchUserInfo()
    this.$nextTick(() => {
      this.setScale()
      this.observePageResize()
    })
    window.addEventListener('resize', this.setScale)
  },
  beforeDestroy() {
    teardownPageScaleObserver(this)
    window.removeEventListener('resize', this.setScale)
  },
  methods: {
    handleLocaleCommand(locale) {
      if (!locale || locale === getCurrentLocale()) return
      setPortalLocale(locale)
    },
    getSafeImageLocal(src) {
      return getSafeImage(src)
    },
    onImgError(event) {
      handleImgError(event)
    },
    // 设置缩放比例 - 基于1920基准尺寸等比缩放
    setScale() {
      applyPageScale(this.getPageScaleEl())
    },

    getPageScaleEl() {
      return this.$refs.homePage
    },

    observePageResize() {
      setupPageScaleObserver(this, () => this.getPageScaleEl())
    },
    
    // 加载配置
    loadConfig() {
      this.config = getHomeConfig(getCurrentLocale())
    },

    // 加载发布成果 / 发布需求数量
    async loadPublishStats() {
      try {
        const [achievementRes, requirementRes] = await Promise.all([
          supplyDemandApi.getAchievementNum(),
          supplyDemandApi.getRequirementNum()
        ])

        const achievementResult = achievementRes.data || {}
        if (achievementResult.status === 0 && typeof achievementResult.data === 'number') {
          this.publishedNumber = achievementResult.data
        }

        const requirementResult = requirementRes.data || {}
        if (requirementResult.status === 0 && typeof requirementResult.data === 'number') {
          this.pendingNumber = requirementResult.data
        }
      } catch (error) {
        // 接口异常时保留默认值
        // eslint-disable-next-line no-console
        console.error('加载发布统计数据失败:', error)
      }
    },

    // 加载科技动态（新闻中心 / 通知公告 / 路演与直播）
    async loadTechNews() {
      try {
        // techTrends.tabs: news-新闻中心(type=2), notice-通知公告(type=1), roadshow-路演与直播(type=8)
        const typeMap = {
          news: 2,
          notice: 1,
          roadshow: 8
        }
        const type = typeMap[this.activeTechTab] || 2

        const response = await getNoticeList({
          page: 0,
          pageSize: 7,
          type
        })
        const result = response.data || {}
        if (result.status === 0 && result.data) {
          const list = result.data.rows || []
          this.techNewsList = list.map(item => {
            // 格式化日期（createTime是时间戳）
            let dateText = ''
            if (item.createTime) {
              const date = new Date(item.createTime)
              const year = date.getFullYear()
              const month = String(date.getMonth() + 1).padStart(2, '0')
              const day = String(date.getDate()).padStart(2, '0')
              dateText = `${year}-${month}-${day}`
            }
            
            return {
              id: item.id,
              title: item.title || '',
              date: dateText,
              content: item.content || ''
            }
          })
        }
      } catch (error) {
        console.error('加载科技动态失败:', error)
        this.techNewsList = []
      }
    },

    // 加载政策信息（科技政策 / 政策解读）
    async loadPolicyNews() {
      try {
        // policyInfo.tabs: tech-科技政策(type=3), interpret-政策解读(type=4)
        const typeMap = {
          tech: 3,
          interpret: 4
        }
        const type = typeMap[this.activePolicyTab] || 3

        const response = await getNoticeList({
          page: 0,
          pageSize: 7,
          type
        })
        const result = response.data || {}
        if (result.status === 0 && result.data) {
          const list = result.data.rows || []
          this.policyNewsList = list.map(item => {
            // 格式化日期（createTime是时间戳）
            let dateText = ''
            if (item.createTime) {
              const date = new Date(item.createTime)
              const year = date.getFullYear()
              const month = String(date.getMonth() + 1).padStart(2, '0')
              const day = String(date.getDate()).padStart(2, '0')
              dateText = `${year}-${month}-${day}`
            }
            
            return {
              id: item.id,
              title: item.title || '',
              date: dateText,
              source: item.source || '',
              content: item.content || ''
            }
          })
        }
      } catch (error) {
        console.error('加载政策信息失败:', error)
        this.policyNewsList = []
      }
    },

    // 搜索
    handleSearch() {
      const keyword = this.searchKeyword.trim()
      if (!keyword) return
      reportSearchIfKeyword(keyword, 'portal')
      const url = `https://www.ylnkzh.cn/pcs-map/#/search?query=${encodeURIComponent(keyword)}`
      window.location.href = url
    },

    // 热门搜索点击
    handleHotSearch(keyword) {
      this.searchKeyword = keyword
      this.handleSearch()
    },

    // 功能模块点击
    handleModuleClick(module) {
      console.log('点击模块:', module.name)
      
      // 根据模块ID跳转
      const routeMap = {
        'innovation': '/innovation',
        'supply': '/supply-demand',
        'evaluation': '/value-assessment',
        'manager': '/manager',
        'transaction': '/transaction',
        'talent': '/talent',
        'enterprise': '/agriculture-enterprise',
        'policy': '/policy'
      }
      
      const route = routeMap[module.id] || module.link
      if (route) {
        this.$router.push(route)
      }
    },

    // 新闻点击（section: tech 科技动态 | policy 政策信息）
    handleNewsClick(item, section = 'tech') {
    const isTech = section === 'tech'
    const currentList = isTech ? this.techNewsList : this.policyNewsList
    setNewsNavList(currentList.map(normalizeNewsNavItem))
    const navKey = (suffix) => getText(`homePage.newsNav.${suffix}`)
    const currentLabel = isTech
      ? (this.activeTechTab === 'notice'
        ? navKey('noticeDetail')
        : (this.activeTechTab === 'roadshow' ? navKey('roadshowDetail') : navKey('newsCenterDetail')))
      : (this.activePolicyTab === 'tech' ? navKey('techPolicyDetail') : navKey('policyInterpretDetail'))
    const titlePair = isTech
      ? { title1: navKey('techTitle1'), title2: navKey('techTitle2') }
      : { title1: navKey('policyTitle1'), title2: navKey('policyTitle2') }
    this.$router.push({
      name: 'newsDetail',
      params: { id: item.id },
      query: {
        title: item.title,
        date: item.date,
        source: item.source || '',
        content: encodeURIComponent(item.content || ''),
        parentLabel: isTech ? (this.config.techTrends?.title || '') : (this.config.policyInfo?.title || ''),
        parentPath: '/policy',
        currentLabel,
        title1: titlePair.title1,
        title2: titlePair.title2
      }
    })
  },

    // 更多点击
    handleMoreClick(type) {
      // 统一跳转政策信息样式列表页，并按来源传入类型和标题
      let targetType = 4
      let title1 = '政策'
      let title2 = '信息'

      if (type === 'tech') {
        // 科技动态 tabs: news(type=2), notice(type=1), roadshow(type=8)
        if (this.activeTechTab === 'notice') targetType = 1
        else if (this.activeTechTab === 'roadshow') targetType = 8
        else targetType = 2
        title1 = '科技'
        title2 = '动态'
      } else if (type === 'policy') {
        // 政策信息 tabs: tech(type=3), interpret(type=4)
        targetType = this.activePolicyTab === 'tech' ? 3 : 4
        title1 = '政策'
        title2 = '信息'
      }

      this.$router.push({
        name: 'policyInfo',
        query: {
          type: String(targetType),
          title1,
          title2
        }
      })
    },

    // 发布需求（我要发布）
    handlePublish() {
      const url = '/main/?menuId=9b1e12bd437844b7b94323aa2f17d1fb#/achievement-web/declarant/my-achievement'
      window.open(url, '_blank')
    },

    // AI 机器人菜单
    toggleAiMenu() {
      this.aiMenuVisible = !this.aiMenuVisible
    },
    handleAiMenuClick(item) {
      console.log('点击AI菜单：', item)

      // 专家咨询：弹窗
      if (item.key === 'consult') {
        this.consultProject = {}
        this.consultVisible = true
        this.aiMenuVisible = false
        return
      }

      // 外链跳转（发布类 / 入驻类）
      const externalUrlMap = {
        // 发布成果
        result: '/main/?menuId=9b1e12bd437844b7b94323aa2f17d1fb#/achievement-web/declarant/my-achievement',
        // 发布需求
        need: '/main/?menuId=f27d85349b7a40ee9cd303a1cb86cff2#/requirement-web/declarant/my-requirement',
        // 单位入驻
        org: '/main/#/register',
        // 人才入驻（与单位入驻同一链接）
        talent: '/main/#/register',
        // 智能问答
        qa: '/wd/index.html'
      }

      const externalUrl = externalUrlMap[item.key]
      if (externalUrl) {
        window.open(externalUrl, '_blank')
        this.aiMenuVisible = false
        return
      }

      // 站内路由跳转
      const routeMap = {
        help: '/help'
      }
      const route = routeMap[item.key]
      if (route) {
        this.$router.push(route)
      }
      // 关闭菜单
      this.aiMenuVisible = false
    },

    // 获取用户信息
    async fetchUserInfo() {
      this.loadingUser = true
      try {
        const res = await request({
          url: '/uoc/umc/user/my/q/simpleinfo',
          method: 'get'
        })
        const result = res.data || {}
        if (result.status === 0 && result.data) {
          const data = result.data
          this.isLoggedIn = true
          this.userInfo = {
            nickName: data.nickName || data.userId || '',
            userId: data.userId || '',
            avatar: data.avatar
              ? (String(data.avatar).startsWith('http') ? data.avatar : data.avatar)
              : ''
          }
        } else {
          this.isLoggedIn = false
          this.userInfo = { nickName: '', userId: '', avatar: '' }
        }
      } catch (error) {
        console.error('获取用户信息失败:', error)
        this.isLoggedIn = false
        this.userInfo = { nickName: '', userId: '', avatar: '' }
      } finally {
        this.loadingUser = false
      }
    },

    // 登录
    handleLogin() {
      const currentUrl = encodeURIComponent(window.location.href)
      window.open(`/main/#/login?redirectURL=${currentUrl}`, '_blank')
      // 监听窗口焦点，当用户返回时刷新用户信息
      this.setupAuthCheck()
    },

    // 注册
    handleRegister() {
      window.open('/main/#/register', '_blank')
      // 监听窗口焦点，当用户返回时刷新用户信息
      this.setupAuthCheck()
    },

    // 设置登录检查
    setupAuthCheck() {
      // 当窗口重新获得焦点时，检查用户是否已登录
      const checkUser = () => {
        this.fetchUserInfo()
      }
      window.addEventListener('focus', checkUser, { once: true })
    },

    handleUserCenter() {
      // 与通用头部一致：已登录点击用户名跳转用户中心首页（同标签）
      try {
        window.location.assign('/vportal-default/#/home')
      } catch (e) {
        window.location.href = '/vportal-default/#/home'
      }
    },

    // 退出
    async handleLogout() {
      // 与通用头部一致：先调用登出接口，再清理本地态
      try {
        await commonApi.logoutApi()
      } catch (e) {
        // ignore
      } finally {
        this.isLoggedIn = false
        this.userInfo = { nickName: '', userId: '', avatar: '' }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}

.home-page {
  width: 1920px;
  min-height: 100vh;
  background: #ffffff;
  transform-origin: top left;
}

// 顶部导航栏
.top-navbar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 57px;
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(10px);
  z-index: 10;

  .navbar-content {
    max-width: 1920px;
    height: 100%;
    margin: 0 auto;
    padding: 0 80px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .logo-area {
      display: flex;
      align-items: center;

      .logo {
        height: 40px;
        margin-right: 15px;
      }

      .site-title {
        font-size: 18px;
        color: #fff;
        font-weight: 500;
      }
    }

    .right-cluster {
      display: flex;
      align-items: center;
      gap: 20px;
    }

    .lang-entry {
      .el-dropdown-link {
        display: inline-flex;
        align-items: center;
        color: #fff;
        cursor: pointer;
        font-size: 14px;
        padding: 8px 14px;
        border-radius: 20px;
        border: 1px solid rgba(255, 255, 255, 0.45);
        background: rgba(0, 0, 0, 0.12);
      }

      .el-dropdown-link:hover {
        background: rgba(255, 255, 255, 0.16);
      }
    }

    .auth-area {
      display: flex;
      align-items: center;
      color: #fff;

      .auth-link {
        cursor: pointer;
        font-size: 14px;
        padding: 8px 20px;
        border-radius: 20px;
        transition: all 0.3s;

        &.nick {
          display: inline-flex;
          align-items: center;
          gap: 8px;
        }

        .avatar {
          width: 26px;
          height: 26px;
          border-radius: 50%;
          object-fit: cover;
        }

        &:hover {
          background: rgba(255, 255, 255, 0.2);
        }
      }

      .divider {
        margin: 0 5px;
        opacity: 0.5;
      }
    }
  }
}

// 头部大图
.header-banner {
  position: relative;
  width: 1920px;
  height: 479px;
  margin: 0 auto;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  justify-content: center;
  // align-items: center;

  .banner-content {
    text-align: center;
    z-index: 2;
    margin-top: 164px;

    .header-title {
      .title-image {
        width: 443px;
        height: 80px;
      }
    }

    .search-container {
      margin-top: 36px;
      .search-box {
        display: flex;
        align-items: center;
        width: 929px;
        height: 51px;
        background: rgba(255, 255, 255, 0.15);
        border-radius: 2px;
        border: 1px solid rgba(255, 249, 211, 0.36);

        .search-icon {
          width: 18px;
          height: 18px;
          margin-right: 15px;
          margin-left: 19px;
          opacity: 0.9;
        }

        .search-input {
          flex: 1;
          height: 100%;
          border: none;
          outline: none;
          background: transparent;
          font-size: 16px;
          color: #fff;

          &::placeholder {
            color: rgba(255, 255, 255, 0.7);
          }
        }

        .search-button {
          width: 86px;
          height: 51px;
          background: rgba(255, 255, 255, 0.21);
          border-radius: 2px;
          border: none;
          color: #fff;
          font-size: 16px;
          cursor: pointer;
          padding: 0;
          margin-left: 15px;
          transition: all 0.3s;

          &:hover {
            opacity: 0.8;
          }
        }
      }

      .hot-search {
        margin-top: 10px;
        color: #fff;
        font-size: 14px;
        display: flex;
        
        .hot-title {
          margin-right: 15px;
        }

        .hot-keyword {
          margin-right: 20px;
          cursor: pointer;
          border-radius: 15px;
          transition: all 0.3s;

          &:hover {
            background: rgba(255, 255, 255, 0.3);
          }
        }
        .action-box{
          flex: 1;
          text-align: right;
          
          cursor: pointer;
        }
      }
    }

    .quick-links {
      margin-top: 30px;
      display: flex;
      justify-content: center;
      gap: 30px;

      .link-item {
        color: #fff;
        font-size: 14px;
        cursor: pointer;
        padding: 8px 20px;
        border: 1px solid rgba(255, 255, 255, 0.5);
        border-radius: 20px;
        transition: all 0.3s;

        &:hover {
          background: rgba(255, 255, 255, 0.2);
          border-color: #fff;
        }
      }
    }
  }

  .ai-service {
    position: absolute;
    left: 120px;
    top: 260px;
    width: 197px; // 与机器人宽度一致，方便绝对定位菜单
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 5;

    .ai-robot {
      position: relative;
      cursor: pointer;
      animation: float 3s ease-in-out infinite;

      .robot-icon {
        width: 197px;
        height: 154px;
        display: block;
      }

      .ai-hi {
        position: absolute;
        top: 18px;
        right: -12px;
        width: 34px;
        height: 27px;
        display: block;
      }
    }

    .ai-menu {
      position: absolute;
      top: 118px; // 往上收一点，让菜单更贴近机器人
      left: 20px; // 居中到机器人下方 (约等于 (197-156)/2)
      width: 156px;
      height: 330px;
      background-image: url('~@/assets/img/ai/ai-list.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);
      border-radius: 16px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      overflow: hidden;
      padding-top: 10px;
    }

    .ai-menu-item {
      text-align: center;
      width: 100%;
      padding: 10px 36px;
      display: flex;
      align-items: center;
      cursor: pointer;
      color: #8D7D2A;
      font-size: 14px;
      transition: background 0.2s, transform 0.2s;

      &:hover {
        background: rgba(255, 255, 255, 0.35);
        transform: translateX(2px);
      }

      .ai-menu-icon {
        width: 20px;
        height: 20px;
        margin-right: 10px;
        flex-shrink: 0;
      }

      .ai-menu-text {
        white-space: nowrap;
      }
    }
  }
}

.ai-menu-fade-enter-active,
.ai-menu-fade-leave-active {
  transition: all 0.2s ease-out;
}

.ai-menu-fade-enter,
.ai-menu-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

// 功能模块
.function-modules {
  margin-top: -60px;
  width: 1714px;
  margin-left:  103px;
  margin-right: 103px;
  position: relative;
  z-index: 3;

  .modules-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    border-radius: 15px;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
    padding: 20px 25px;

    .module-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      cursor: pointer;
      transition: all 0.3s;
      padding: 10px 8px;
      border-radius: 8px;

      &:hover {
        background: rgba(74, 159, 216, 0.05);
        transform: translateY(-3px);

        .module-icon {
          background: transparent;

          img {
            transform: scale(1.1);
          }
        }
      }

      .module-icon {
        width: 62px;
        height: 61px;
        background: transparent;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
        flex-shrink: 0;
        transition: all 0.3s;

        img {
          width: 62px;
          height: 61px;
          object-fit: contain;
          transition: transform 0.3s;
        }
      }

      .module-info {
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .module-name {
          font-size: 15px;
          color: #333;
          font-weight: 500;
          line-height: 1.3;
          margin-bottom: 2px;
        }

        .module-en-name {
          font-size: 9px;
          color: #C7C2A5;
          text-transform: uppercase;
          letter-spacing: 0.3px;
          line-height: 1;
        }
      }
    }
  }
}

// 内容区域
.content-area {
  margin-bottom: 50px;
  margin-top: 16px;
  background: #fff;
  width: 1714px;
  margin-left: 103px;
  margin-right: 103px;
  
  .content-wrapper {
    display: grid;
    grid-template-columns: 700px 700px 314px;

    .publish-demand {
      background-size: cover;
      background-position: center;
      border-radius: 10px;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      min-height: 400px;

      .demand-section {
        margin-bottom: 25px;
        text-align: center;

        .section-title {
          font-family: Source Han Sans CN;
          font-weight: 400;
          font-size: 14px;
          color: #2270FF;
          line-height: 22px;
        }

        .number-display {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;

          .digit-box {
            width: 24px;
            height: 35px;
            background-image: url('~@/assets/img/shouye/fabu-item-bg.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            background-position: center;
            border: none;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 24px;
            font-weight: 600;
            color: #4a9fd8;
            font-family: 'Arial', 'Helvetica', sans-serif;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          }

          .unit-text {
            font-size: 16px;
            color: #4a9fd8;
            margin-left: 4px;
            font-weight: 500;
          }
        }
      }

      .demand-subtitle {
        margin-bottom: 25px;
        margin-top: 10px;
        text-align: center;
        font-family: FZZhengHeiS-M-GB;
        font-weight: 400;
        font-size: 18px;
        color: #333333;
        line-height: 22px;
      }

      .demand-button {
        cursor: pointer;
        transition: transform 0.3s;

        &:hover {
          transform: scale(1.05);
        }

        img {
          width: 208px;
          height: 85px;
        }
      }
    }
  }
}


// 中文设计稿字号（仅 zh-CN）
.home-page.locale-zh-CN {
  .top-navbar .navbar-content {
    .logo-area .site-title {
      font-size: 35px;
    }

    .lang-entry .el-dropdown-link,
    .auth-area .auth-link {
      font-size: 18px;
    }
  }

  .function-modules .modules-container .module-item .module-info {
    .module-name {
      font-size: 20px;
    }

    .module-en-name {
      font-size: 12px;
    }
  }

  ::v-deep .news-block.theme-homepage {
    .block-header {
      .header-left .block-title {
        font-size: 25px;
      }

      .header-tabs .tab-item {
        font-size: 20px;
      }

      .more-link {
        font-size: 16px;
      }
    }

    .block-content .news-item {
      .news-title {
        font-size: 18px;
      }

      .news-date {
        font-size: 16px;
      }
    }
  }

  .content-area .content-wrapper .publish-demand {
    .demand-section .section-title {
      font-size: 18px;
    }

    .demand-section .number-display .digit-box {
      width: 28px;
      height: 40px;
      font-size: 28px;
    }

    .demand-subtitle {
      font-size: 20px;
    }

    .demand-button img {
      width: 258px;
      height: 112px;
    }
  }
}
</style>
